// extracted by mini-css-extract-plugin
module.exports = {"container":"e2ff468f85--container--Q2x1Z","image":"e2ff468f85--image--GZNx2","description":"e2ff468f85--description--OzRpj"};